/*
 * File: CustomDragnDrop.tsx
 * Project: a-a
 * File Created: Tuesday, 18th February 2025 2:14:45 am
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 20th February 2025 1:30:21 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import React, { useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import zeplinColor from '../../../theme/Color';
import { Box, Typography } from '@mui/material';

export default function CustomDragnDrop({ onDrop }: { onDrop: (acceptedFile: any) => void }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div
      style={{
        borderStyle: 'dashed',
        borderWidth: '1px',
        borderColor: zeplinColor.Neutral6,
        backgroundColor: zeplinColor.Neutral1,
        // marginLeft: 10,
        height: '105px',
        borderRadius: '14px',
        width: '100%',
      }}
      // className='upload-btn'
      {...getRootProps({ className: 'dropzone upload-btn' })}
    >
      <input {...getInputProps()} />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          flexDirection: 'column',
        }}
      >
        <img
          width={'24px'}
          height={'24px'}
          src={'/assets/upload.svg'}
          alt='logo'
          style={{ objectFit: 'fill' }}
        />
        {isDragActive ? (
          <Typography variant='body3' color={zeplinColor.Neutral8}>
            Drop or Browse files to attach
          </Typography>
        ) : (
          <Typography variant='body3' color={zeplinColor.Neutral8}>
            Drop or Browse files to attach
          </Typography>
        )}
      </Box>
    </div>
  );
}
